module.exports = __webpack_public_path__ + "img/pause-circle.0b4dc107.svg";